import React from "react";
import PropTypes from "prop-types";

const SelectInput = ({
  name,
  label,
  value,
  onChange,
  required,
  isLabeled,
  textWhite,
  ...props
}) => {
  return (
    <div
      className={textWhite ? "form-group text-white" : "form-group"}
    >
      <label>
        {label}
        <span className="text-danger">*</span>
      </label>
      <select
        data-toggle="select2"
        title={label}
        className="form-control "
        data-live-search="true"
        name={name}
        value={value}
        onChange={onChange}
        required={required}
      >
        {isLabeled ? <option value="">{label}</option> : null}
        {props.children}
      </select>
    </div>
  );
};

SelectInput.propTypes = {
  name: PropTypes.string,
  children: PropTypes.any,
  value: PropTypes.any.isRequired,
  label: PropTypes.string.isRequired,
  required: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  isLabeled: PropTypes.bool.isRequired,
  textWhite: PropTypes.bool.isRequired
};

export default SelectInput;
